export function DetailItem({
  label,
  value,
  sub,
  icon,
}: {
  label: string;
  value: string;
  sub?: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="space-y-1">
      <span className="text-[11px] font-bold uppercase tracking-widest text-slate-400">{label}</span>
      <div className="flex items-center gap-1.5 font-semibold text-slate-900">
        {icon}
        {value}
      </div>
      {sub && <p className="text-xs text-slate-500 ml-[22px]">{sub}</p>}
    </div>
  );
}
